import * as React from "react";
import { ProjectSPModel } from "../../../models/ProjectSPModel";
import { Grid, Typography } from "@mui/material";
import { displayDateFormart } from "../../../utility/utils";

interface IBasicInfoSection {
  data: ProjectSPModel;
}

const getFinancialYear = (createdDate: string | number | Date) => {
  if (!(createdDate instanceof Date)) {
    createdDate = new Date(createdDate);
  }

  const month = createdDate.getMonth();
  const year = createdDate.getFullYear();

  if (month >= 3) {
    // If the month is April or later, the financial year is the current year.
    return (year % 100).toString(); // Display the last two digits of the year.
  } else {
    // If the month is before April, the financial year is the previous year.
    return ((year - 1) % 100).toString(); // Display the last two digits of the previous year.
  }
};

export const BasicInfoSection = (props: IBasicInfoSection) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Opportunity code
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.sbgName) || "NA"} - {""}
          {(props.data && props.data.sbuName) || "NA"} - {""}
          {(props.data && props.data.buName) || "NA"} - {""}
          {props.data && props.data.createdDate
            ? `FY${getFinancialYear(props.data.createdDate)}`
            : "NA"}{" "}
          - {""}
          {(props.data && props.data.projectId) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Bid Status
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.projectOverallWinLossStatus) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Bid Submission Date
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && displayDateFormart(props.data.bidSubmissionDate)) ||
            "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Lead/Opportunity Qualification
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.opportunityQualification) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Bid Manager
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.bidManagerName) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Work as per new T&E
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isNewTeprocessCommenced === true
            ? "Yes"
            : props.data.isNewTeprocessCommenced === false
            ? "No"
            : "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Work Started
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isWorkStarted === true
            ? "Yes"
            : props.data.isWorkStarted === false
            ? "No"
            : "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          SBG
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.sbgName) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          SBU
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.sbuName) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          BU/LOB
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.buName) || "NA"}
        </Typography>
      </Grid>

      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Segment
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.segmentLob) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Customer Name
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.customerName) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Segment Classification
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.segmentClassification) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Base Load
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isBaseLoad ? "Yes" : "No"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Green Customer
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isGreenListCustomer ? "Yes" : "No"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Brief Scope
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.briefScope) || "Na"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Estimated Value (INR Cr)
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.estimatedValue
            ? props.data.estimatedValue.toLocaleString("en-IN")
            : "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Pre-Bid Expenses (INR Lac)
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.preBidExpenses
            ? props.data.preBidExpenses.toLocaleString("en-IN")
            : "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Values Slab
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.valueSlab) || "NA"}
        </Typography>
      </Grid>
      {/* <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          New Process Applicable
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isNewProcessApplicable ? "Yes" : "No"}
        </Typography>
      </Grid> */}
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Contract Type
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.contractType) || "NA"}
        </Typography>
      </Grid>
      {props.data.contractType === "Others" && (
        <Grid item xs={6} sm={4}>
          <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
            Other Contract Type
          </Typography>
          <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
            {(props.data && props.data.otherContractType) || "NA"}
          </Typography>
        </Grid>
      )}
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Price Variation
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.isPriceVariation) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Assess Customer Rating
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.assessCustomerRating) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          PQ Required
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.isPqrequired) || "NA"}
        </Typography>
      </Grid>
      {/* {props.data.isPqrequired === "Yes" && (
          <Grid item xs={6} sm={4}>
            <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
              PQ Requirements
            </Typography>
            <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
              {(props.data && props.data.preQualificationRequirement) || "NA"}
            </Typography>
          </Grid>
        )} */}
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          JV Partner Requirement
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isJvpartnerRequired ? "Yes" : "No"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          JV Partner Suggested Name
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.jvpartnerSuggestedName) || "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Tech Partner Requirement
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {props.data && props.data.isTechPartnerRequired ? "Yes" : "No"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography variant="subtitle2" style={{ fontWeight: "bolder" }}>
          Tech Partner Suggested Name
        </Typography>
        <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
          {(props.data && props.data.techPartnerSuggestedName) || "NA"}
        </Typography>
      </Grid>
    </Grid>
  );
};
